var _react_refresh_temp_1, _react_refresh_temp_2;
import { z } from 'zod';
import { enumParser, MemberType, UNKNOWN_ENUM_VALUE } from '#validation';
import { serviceAccountRefSchema } from '#web-service-api/service-account';
import { userAccountRefSchema } from '#web-service-api/user';
export const GroupUserMembershipResponseSchema = userAccountRefSchema.extend({
    type: z.literal(MemberType.USER),
});
export const GroupServiceAccountMembershipResponseSchema = serviceAccountRefSchema.extend({
    type: z.literal(MemberType.SERVICE_ACCOUNT),
});
export const GroupUnknownMembershipResponseSchema = z.looseObject({
    id: z.string(),
    type: z.literal(UNKNOWN_ENUM_VALUE),
});
const GroupMembershipResponseSchema = z.discriminatedUnion('type', [
    GroupUserMembershipResponseSchema,
    GroupServiceAccountMembershipResponseSchema,
    GroupUnknownMembershipResponseSchema,
]);
const handledMemberTypeParser = enumParser({
    USER: MemberType.USER,
    SERVICE_ACCOUNT: MemberType.SERVICE_ACCOUNT,
});
export const GroupMembershipsResponseSchema = z.preprocess(_react_refresh_temp_1 = (input) => {
    const result = z
        .looseObject({ type: handledMemberTypeParser })
        .safeParse(input);
    return result.success ? result.data : input;
}, GroupMembershipResponseSchema);
$RefreshReg$(_react_refresh_temp_1, "GroupMembershipsResponseSchema$z.preprocess");
_react_refresh_temp_2 = GroupMembershipsResponseSchema;
$RefreshReg$(_react_refresh_temp_2, "GroupMembershipsResponseSchema");
